import getApiClient from '@/plugins/api-client'
import axios from 'axios'
import ibgeCityService from '@/services/ibgeCityService'
import {accentInsensitiveFilter, highlightParts} from '@/helpers/textNormalizerHelper'

const moment = require('moment-timezone')
import {
    availableBarsRestaurantsJobTypes,
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

import Vue from 'vue'

export default {
    cityFilter: accentInsensitiveFilter,

    cityHighlight: highlightParts,

    saveEvent: function () {
        const self = this,
            api = getApiClient(self.$store)

        let data = self.prepareEventData()

        self.resetFormMessages()

        let method = data['@id'] ? 'patch' : 'post',
            route = (method === 'post' ? 'events' : data['@id']),
            options = {}

        if (method === 'patch') {
            options.headers = {
                'Content-Type': 'application/merge-patch+json'
            }
        }

        const profileSearchesData = self.event.profileSearches.filter(profileSearch => {
            return profileSearch['@id'] !== undefined
        })

        profileSearchesData.forEach(profileSearch => {
            profileSearch.id = profileSearch['@id']
        })

        new Promise((resolve, reject) => {
            if (profileSearchesData.length) {
                api.put(`events/${self.event.id}`, {
                    profileSearches: profileSearchesData
                }).then(() => {
                    resolve()
                }).catch(error => {
                    let response = error.response
                    switch (response.status) {
                        case 400:
                        case 422:
                            if (error.response.data.violations) {
                                error.response.data.violations.forEach((violation) => {
                                    Vue.set(self.errors, violation.propertyPath, violation.message)
                                })
                            }
                            break;
                        default:
                            self.showErrorMessage('Ocorreu um erro ao cadastrar o evento')
                            break;
                    }
                    reject()
                })

                return
            }

            resolve()
        }).then(() => {
            api[method](route, data, options)
              .then(result => {
                  self.showSuccessMessage('Evento salvo com sucesso!')
                  self.isSaved = true

                  if (!result.data.address) {
                      result.data.address = {
                          zipCode: '',
                          street: '',
                          number: null,
                          complement: '',
                          neighbourhood: '',
                          city: '',
                          state: ''
                      }
                  }

                  self.event = result.data
                  if (self.event.address && self.event.address.state) {
                      self.loadCitiesForState(self.event.address.state)
                  }
                  self.oneDayEvent = self.event.totalDays === 1

                  if (self.oneDayEvent) {
                      self.event.dates.push({
                          startDate: null,
                          endDate: null,
                          startTime: null,
                          endTime: null,
                          start: null,
                          end: null,
                          displayDate: null
                      })
                  }
                  self.$store.commit('setCreatingEvent', self.event.id)

                  const profileFinder = self.$store.state.profileFinder
                  if (profileFinder) {
                      profileFinder.event = self.event
                      self.$store.commit('setProfileFinder', profileFinder)
                  }

                  if (self.$route.name === 'ContractorEventForm' || self.$route.name === 'ContractorCloneEventForm') {
                      if (!self.event.profileSearches.length) {
                          self.appendProfileSearch()
                      }

                      self.event.profileSearches.forEach(profile => {
                          self.updateJobTypeOptions(profile)
                      })
                  }

                  self.$router.push({
                      name: self.isCloning ? 'ContractorCloneEventForm' : 'ContractorEventForm',
                      hash: '#select-professional',
                      params: {
                          id: self.event.id
                      }
                  }, function () {
                      if (!self.event.profileSearches.length) {
                          self.appendProfileSearch()
                      }
                  })
              })
              .catch(error => {
                  let response = error.response
                  switch (response.status) {
                      case 400:
                      case 422:
                          if (error.response.data.violations) {
                              error.response.data.violations.forEach((violation) => {
                                  Vue.set(self.errors, violation.propertyPath, violation.message)
                              })
                          }
                          break;
                      default:
                          self.showErrorMessage('Ocorreu um erro ao cadastrar o evento')
                          break;
                  }
              })
              .finally(() => {
                  self.$store.commit('stopLoading')
              })
        })
    },

    prepareEventData: function () {
        const self = this

        let result = {...self.event}

        if (self.oneDayEvent) {
            result.dates = [
                self.event.dates[0]
            ]
        }

        if (result.isRemote) {
            delete result.address
        }

        if (!result.category) {
          result.category = null
          self.event.category = null
        }

        result.dates.forEach(date => {
            if (date.startDate && date.startTime) {
                let startDate = moment(date.startDate).format('YYYY-MM-DD')
                date.start = moment(`${startDate} ${date.startTime}`)
            }

            if (date.endTime) {
                let endDate = date.startDate
                date.endDate = date.startDate
                date.end = moment(`${endDate} ${date.endTime}`)
            }

            if (
                date.end &&
                (parseInt(date.end.format('H')) < parseInt(date.start.format('H'))) &&
                (date.start.format('YYYY-MM-DD') === date.end.format('YYYY-MM-DD'))
            ) {
                date.end = date.end.add(1, 'days')
            }
        })

        delete result.profileSearches

        result.dates.forEach(date => {
            if (date.start) {
                date.start = date.start.format()
            }
            if (date.end) {
                date.end = date.end.format()
            }
        })

        if (result.jobs) {
            result.jobs = result.jobs.map(job => {
                if (job['@id']) {
                    return job['@id']
                }
            })
        }

        if (result.start) {
            delete result.start
        }

        if (result.end) {
            delete result.end
        }

        return result
    },

    loadCitiesForState: async function (uf, callback = null) {
        const self = this
        if (!uf) {
            self.availableCities = []
            return
        }
        self.isLoadingCities = true
        const api = getApiClient(self.$store)
        const cities = await ibgeCityService.getCitiesByUf(api, uf)
        self.availableCities = cities
        self.isLoadingCities = false
        if (typeof callback === 'function') {
            callback(cities)
        }
    },

    onStateChange: function (newState) {
        const self = this
        if (!newState) {
            self.availableCities = []
            self.event.address.city = ''
            return
        }
        self.loadCitiesForState(newState, (cities) => {
            if (self.event.address.city && !cities.includes(self.event.address.city)) {
                self.event.address.city = ''
            }
        })
    },

    loadAddressByZipCode: function () {
        const self = this,
            zipCode = self.event.address.zipCode.replace(/[^0-9]/g, ''),
            endpoint = `https://viacep.com.br/ws/${zipCode}/json/`

        if (zipCode.length === 8) {
            axios.get(endpoint)
                .then((result) => {
                    let data = result.data
                    if (data && !data.erro) {
                        self.event.address.street = data.logradouro || self.event.address.street
                        self.event.address.neighbourhood = data.bairro || self.event.address.neighbourhood
                        self.event.address.state = data.uf
                        if (data.uf) {
                            self.loadCitiesForState(data.uf, (cities) => {
                                if (data.localidade) {
                                    const matched = (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'accent' }) === 0)
                                        || (cities || []).find(c => c.localeCompare(data.localidade, undefined, { sensitivity: 'base' }) === 0)
                                    self.event.address.city = matched || ''
                                } else {
                                    self.event.address.city = ''
                                }
                            })
                        } else {
                            self.event.address.city = ''
                        }
                    }
                })
                .catch(() => {
                })
        }
    },

    resetFormMessages: function () {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = ''
        })
    },

    validateTime: function (time, allowMidnight = true) {
        if (time) {
            if (!time.includes(':')) {
                time += ':00'
            }
            if (time.match(/[0-9]{2}:[0-9]{1}$/g)) {
                time += '0'
            }

            if (time === '24:00') {
                time = '00:00'
            }

            let hourMinute = time.split(':'),
                hour = hourMinute[0],
                minute = hourMinute[1]

            if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
                return null
            }

            if (! allowMidnight && hour === '00') {
                time = '23:59'
            }
        }

        return time
    },

    validateDate: function (date) {
        if (date.displayDate) {
            let parsedDate = this.parseDate(date.displayDate)

            if (moment(parsedDate).isValid()) {
                date.startDate = parsedDate
                return date
            } else {
                date.displayDate = null
                date.startDate = null
            }
        }

        return null
    },

    parseDate: function (date) {
        if (date) {
            let splittedDate = date.split('/'),
                year = splittedDate[2],
                month = splittedDate[1],
                day = splittedDate[0]

            return `${year}-${month}-${day}`
        }

        return null
    },

    showErrorMessage: function (message) {
        const self = this

        self.errorMessage.content = message
        self.errorMessage.show = true
    },

    showSuccessMessage: function (message) {
        const self = this

        self.successMessage.content = message
        self.successMessage.show = true
    },

    removeDate: function (dateIndex) {
        this.$delete(this.event.dates, dateIndex)
    },

    normalizeInterval: function (event) {
        const self = this

        let dates = event.dates,
            firstDate = moment(dates[0].startDate),
            startTime = dates[0].startTime,
            lastDate = moment(dates[dates.length - 1].startDate),
            endTime = dates[0].endTime,
            diff = lastDate.diff(firstDate, 'days')

        if (event.dates.length > 2) {
            event.dates = [
                dates[0],
                dates[dates.length - 1]
            ]
        }

        for (let i = 1; i < diff; i++) {
            let increasedDate = firstDate.add(1, 'days')

            event.dates.splice(i, 0, {
                displayDate: increasedDate.format('DD/MM/YYYY'),
                startDate: increasedDate.format('YYYY-MM-DD'),
                endDate: increasedDate.format('DD/MM/YYYY'),
                startTime: self.fixedEventTime ? startTime : null,
                endTime: self.fixedEventTime ? endTime : null,
                start: null,
                end: null
            })
        }

        if (self.fixedEventTime) {
            dates[dates.length - 1].startTime = startTime
            dates[dates.length - 1].endTime = endTime
        }

        self.showNormalizeInterval = false
    },

    setFixedTime() {
        if (this.fixedEventTime) {
            let dates = this.event.dates

            let firstDate = dates[0]

            dates.forEach(date => {
                date.startTime = firstDate.startTime
                date.endTime = firstDate.endTime
            })
        }
    },

    updateJobTypeOptions: function (profile, resetType) {
        if (resetType) {
            profile.type = null
        }
        switch (profile.category) {
            case 'casting':
                profile.types = availableCastingJobTypes
                break;
            case 'event_support':
                profile.types = availableEventSupportJobTypes
                break;
            case 'bars_restaurants':
                profile.types = availableBarsRestaurantsJobTypes
                break;
            case 'master_of_ceremonies':
                profile.types = availableMasterOfCeremoniesJobTypes
                break;
            default:
                profile.types = []
                break;
        }
    },

    appendProfileSearch: function () {
        if (this.canAppendProfessionalSearch) {
            this.event.profileSearches.push({
                category: null,
                types: [],
                quantity: null,
                type: null,
                id: null,
                foodIncluded: false
            })
        }
    },

    removeProfileSearch: function (index, deletedProfileSearch = null) {
        const self = this,
            api = getApiClient(self.$store),
            event = self.event,
            deleted = deletedProfileSearch

        self.$delete(self.event.profileSearches, index)

        const profileSearches = {...self.event.profileSearches}

        Object.keys(profileSearches).forEach(profileSearchIndex => {
            profileSearches[profileSearchIndex].id = profileSearches[profileSearchIndex]['@id']
        })

        api.put(`events/${event.id}`, {
            profileSearches: profileSearches
        })
            .then(() => {
                if (deleted && deleted.id) {
                    let profileSearches = self.$store.state.profileSearches.filter(profileSearch => {
                        return profileSearch?.id !== deleted.id
                    }),
                        updatedProfileSearches = []

                    profileSearches.forEach(item => {
                        if (item) {
                            updatedProfileSearches[item.id] = item
                        }
                    })

                    self.event.profileSearches.forEach(profileSearch => {
                        profileSearch.id = profileSearch.id.replace(/[^0-9]/g, '')
                    })

                    self.$store.commit('updateProfileSearches', updatedProfileSearches)
                }

                if (!self.event.profileSearches.length) {
                    self.appendProfileSearch()
                }
            })
    },

    openProfessionalFinder: function (profile, currentIndex = null, editing = false) {
        const self = this
        const profileIndex = self.event.profileSearches.findIndex(p => p === profile)

        Vue.set(self.errors, `profileSearches[${profileIndex}].fee`, null)

        if (self.minimumFee > 0 && profile.fee < self.minimumFee) {
            const formatted = self.minimumFee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            Vue.set(self.errors, `profileSearches[${profileIndex}].fee`, `O valor mínimo da diária é ${formatted}`)
            return
        }

        const api = getApiClient(self.$store),
            event = self.event,
            params = {
                category: profile.category,
                type: profile.type,
                quantity: profile.quantity,
                eventId: self.event.id
            }

        if (!self.event.isRemote) {
            params.latitude = self.event.address.latitude
            params.longitude = self.event.address.longitude
        }

        self.$store.commit('setSearchProfileEvent', event)
        self.$store.commit('setProfileSearchFilters', {})

        let patchProfile = profile

        let data = Object.assign(event.profileSearches, patchProfile)
        data.forEach(profileSearch => {
            if (profileSearch['@id']) {
                profileSearch.id = profileSearch['@id']
            }
        })

        api.put(`events/${event.id}`, {
            profileSearches: data
        })
            .then(result => {
                if (!result.data.address) {
                    result.data.address = {
                        zipCode: '',
                        street: '',
                        number: null,
                        complement: '',
                        neighbourhood: '',
                        city: '',
                        state: ''
                    }
                }
                self.event = result.data
                let existingProfiles = []
                if (profile.id) {
                    params.profileSearch = self.event.profileSearches.filter(profileSearch => {
                        return profileSearch['@id'] === profile.id
                    })[0]

                    const profileFinder = {...params.profileSearch}

                    if (self.$store.state.profileSearches.length > 0) {
                        profileFinder.profiles = self.$store.state.profileSearches[profile.id.replace(/[^0-9]/g, '')]?.profiles ?? []
                    } else {
                        profileFinder.profiles = []
                    }
                    profileFinder.result = []
                    profileFinder.event = self.event

                    existingProfiles = profileFinder.profiles

                    self.$store.commit('setProfileFinder', profileFinder)
                } else {
                    params.profileSearch = self.event.profileSearches[self.event.profileSearches.length - 1]
                }

                if (!editing) {
                    if (currentIndex !== null) {
                        const replacedProfile = existingProfiles[currentIndex]

                        if (replacedProfile && replacedProfile['@id']) {
                            self.deleteDraftSelection(replacedProfile['@id'], params.profileSearch.id)
                        }

                        self.$store.commit('setProfileSearchIndex', currentIndex)

                        self.$store.commit('setProfileSearchProfile', {
                            index: currentIndex,
                            profile: {}
                        })
                    } else {
                        self.$store.commit('resetProfileSearchProfiles')
                    }
                } else {
                    if (currentIndex !== null) {
                        self.$store.commit('setProfileSearchIndex', currentIndex)
                    }
                }

                self.$store.commit('saveProfileQuery', params)
                self.$store.commit('setProfileSearchId', params.profileSearch.id)
                this.$router.push({
                    name: 'ProfessionalFinder',
                    hash: '#professional-finder'
                })
            })
            .catch(error => {
                let response = error.response
                switch (response.status) {
                    case 400:
                    case 422:
                        if (error.response.data.violations) {
                            error.response.data.violations.forEach((violation) => {
                                Vue.set(self.errors, violation.propertyPath, violation.message)
                            })
                        }
                        break;
                    default:
                        self.showErrorMessage('Ocorreu um erro ao cadastrar o evento')
                        break;
                }
            })
    },

    deleteDraftSelection: function(workProfileIri, profileSearchId) {
        const self = this,
            api = getApiClient(self.$store),
            eventId = self.event.id,
            eventStatus = self.event.status

        if (!eventId || !profileSearchId || !workProfileIri || eventStatus !== 'creating') {
            return
        }

        // Note: the backend does not expose a `workProfile.id` filter for this
        // resource, so filtering has to happen client-side. Relying on the API
        // to filter by workProfile would silently return (and delete) every
        // draft selection for this profileSearch, wiping out the other already
        // selected professionals whenever quantity > 1.
        api.get('/draft_job_selections', {
            params: {
                'event.id': eventId,
                'profileSearch.id': profileSearchId,
                pagination: false
            }
        }).then(result => {
            const drafts = result.data['hydra:member'] || []
            drafts.filter(draft => {
                const draftWorkProfileIri = draft.workProfile && typeof draft.workProfile === 'object'
                    ? draft.workProfile['@id']
                    : draft.workProfile

                return draftWorkProfileIri === workProfileIri
            }).forEach(draft => {
                api.delete(draft['@id']).catch(error => {
                    console.log('Failed to delete draft selection:', error)
                })
            })
        }).catch(error => {
            console.log('Failed to find draft selection for deletion:', error)
        })
    },

    checkout() {
        const self = this,
            api = getApiClient(self.$store)

        self.saveEvent()
        self.updateFees()
        self.$store.commit('setJobDetails', self.jobDetails)
        self.$store.commit('setProfileSearchFilters', {})
        const profileFinder = self.$store.state.profileFinder
        if (profileFinder) {
            profileFinder.event = self.event
            self.$store.commit('setProfileFinder', profileFinder)
        }

        self.event.profileSearches.forEach(profileSearch => {
            profileSearch.id = profileSearch['@id']
        })

        let data = self.prepareEventData()

        self.resetFormMessages()

        let method = data['@id'] ? 'patch' : 'post',
          route = (method === 'post' ? 'events' : data['@id']),
          options = {}

        if (method === 'patch') {
            options.headers = {
                'Content-Type': 'application/merge-patch+json'
            }
        }

      const profileSearchesData = self.event.profileSearches

      profileSearchesData.forEach(profileSearch => {
        profileSearch.id = profileSearch['@id']
      })

      api.put(`events/${self.event.id}`, {
        profileSearches: profileSearchesData
      }).then(() => {
        api[method](route, data, options)
          .then(result => {
            self.event = result.data
            self.event.profileSearches.forEach(profileSearch => {
              profileSearch.id = profileSearch['@id']
            })
            api.put(`events/${self.event.id}`, {
              profileSearches: self.event.profileSearches
            })
              .then(result => {
                if (!result.data.address) {
                  result.data.address = {
                    zipCode: '',
                    street: '',
                    number: null,
                    complement: '',
                    neighbourhood: '',
                    city: '',
                    state: ''
                  }
                }
                self.event = result.data

                self.$store.commit('updateProfileSearchesFees', self.event.profileSearches)

                self.$router.push({
                  name: 'EventCheckout',
                  params: {
                    id: self.$route.params.id
                  }
                })
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(error => {
            let response = error.response
            switch (response.status) {
              case 400:
              case 422:
                if (error.response.data.violations) {
                  error.response.data.violations.forEach((violation) => {
                    self.errors[violation.propertyPath] = violation.message
                  })
                }
                break;
              default:
                self.showErrorMessage('Ocorreu um erro ao salvar o evento')
                break;
            }
          })
          .finally(() => {
            self.$store.commit('stopLoading')
          })
      })
    },

    addProfileFeeType(type) {
        if (!this.jobDetails.fee[type]) {
            Vue.set(this.jobDetails.fee, type, 0)
        }
    },

    updateFees() {
        const self = this

        self.jobDetails.fee = {}

        self.event.profileSearches.forEach(profileSearch => {
            self.jobDetails.fee[profileSearch.type] = profileSearch.fee
        })
    },

    setDisplayDate(date) {
        if (date.startDate) {
            date.displayDate = moment(date.startDate).format('DD/MM/YYYY')
        }
    },

    loadEvent(eventId) {
        return new Promise((resolve, reject) => {
            {
                const self = this,
                    api = getApiClient(self.$store)

                api.get(`/events/${eventId}`)
                    .then(result => {
                        if (!result.data.address) {
                            result.data.address = {
                                zipCode: '',
                                street: '',
                                number: null,
                                complement: '',
                                neighbourhood: '',
                                city: '',
                                state: ''
                            }
                        }
                        let event = result.data
                        if (event.address && event.address.state) {
                            self.loadCitiesForState(event.address.state)
                        }
                        if (event.jobs.length) {
                            event.jobs = event.jobs.filter(job => {
                                return [0,1].includes(job.status)
                            })
                        }

                        resolve(event)
                    })
                    .catch(error => {
                        reject(error)
                    })
            }
        })
    },

    cancelEvent() {
        const self = this,
            api = getApiClient(self.$store)

        api.patch(self.event['@id'], {status: 'cancelled'}, {headers: {'Content-Type': 'application/merge-patch+json'}})
            .then(() => {
                self.event = {}
                self.$store.commit('setCreatingEvent', null)
                self.$store.commit('resetProfileFinder')
                self.$router.push({name: 'ContractorJobForm'})
                window.setTimeout(() => {
                    location.reload()
                }, 400)
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadDraftSelections(eventId, profileSearchArr) {
        const self = this,
            api = getApiClient(self.$store)

        api.get('/draft_job_selections', {
            params: {
                'event.id': eventId,
                pagination: false
            }
        }).then(result => {
            const drafts = result.data['hydra:member'] || []

            if (!drafts.length) {
                return
            }

            const unavailable = []
            const updatedProfileSearchArr = [...profileSearchArr]
            // Keyed by profileSearchId: collects {workProfile, slotIndex} entries so the
            // original selection order can be restored below, instead of relying on the
            // backend's fetch order (which would push a replaced professional to the end).
            const profilesBySearch = {}

            drafts.forEach(draft => {
                const profileSearch = draft.profileSearch,
                    workProfile = draft.workProfile,
                    profileSearchId = profileSearch ? profileSearch.id : null

                if (!profileSearchId || !workProfile) {
                    return
                }

                if (!draft.available) {
                    unavailable.push(workProfile.user ? workProfile.user.name : 'Profissional')
                    return
                }

                if (!updatedProfileSearchArr[profileSearchId]) {
                    updatedProfileSearchArr[profileSearchId] = {
                        id: profileSearchId,
                        profiles: [],
                        type: draft.profileSearch ? draft.profileSearch.type : null
                    }
                }

                if (!profilesBySearch[profileSearchId]) {
                    profilesBySearch[profileSearchId] = (updatedProfileSearchArr[profileSearchId].profiles || []).map(profile => {
                        return {workProfile: profile, slotIndex: null}
                    })
                }

                const alreadyAdded = profilesBySearch[profileSearchId].some(entry => {
                    return entry.workProfile && entry.workProfile.id === workProfile.id
                })

                if (!alreadyAdded) {
                    profilesBySearch[profileSearchId].push({
                        workProfile,
                        slotIndex: typeof draft.slotIndex === 'number' ? draft.slotIndex : null
                    })
                }
            })

            Object.keys(profilesBySearch).forEach(profileSearchId => {
                updatedProfileSearchArr[profileSearchId].profiles = profilesBySearch[profileSearchId]
                    .slice()
                    .sort((a, b) => {
                        const aIndex = a.slotIndex === null ? Number.MAX_SAFE_INTEGER : a.slotIndex
                        const bIndex = b.slotIndex === null ? Number.MAX_SAFE_INTEGER : b.slotIndex

                        return aIndex - bIndex
                    })
                    .map(entry => entry.workProfile)
            })

            self.$store.commit('updateProfileSearches', updatedProfileSearchArr)
            self.$store.state.jobsSynced = true

            if (unavailable.length) {
                self.unavailableDraftProfessionals = unavailable
                self.showUnavailableAlert = true
            }
        }).catch(error => {
            console.log('Failed to load draft selections:', error)
        })
    }
}
